module.exports = __webpack_public_path__ + "img/Ola_S.b43531fd.jpeg";